import { useState, type FC } from "react";
import type { DocumentViewerFiles } from "../modals/PreviewDocumentModalContent";
import DefaultButton from "../../atoms/buttons/DefaultButton";
import { MergeIcon } from "../../atoms/icons/MergeIcon";
import Modal from "../Modal";
import MergeFilesTogetherModalContent from "../modals/MergeFilesTogetherModalContent";
import { useTranslation } from "react-i18next";

interface Props {
  selectedFiles: Array<DocumentViewerFiles>;
  uploadUnitId: string;
}

const MergeFilesButton: FC<Props> = ({ selectedFiles, uploadUnitId }) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div>
      <DefaultButton
        title={t("documentHandler.mergeFiles")}
        icon={<MergeIcon />}
        onClick={() => setModalOpen(true)}
        size="small"
      />
      {modalOpen && (
        <Modal onClose={() => setModalOpen(false)} closeIcon width={1600}>
          <MergeFilesTogetherModalContent
            files={selectedFiles}
            uploadUnitId={uploadUnitId}
            onClose={() => setModalOpen(false)}
          />
        </Modal>
      )}
    </div>
  );
};

export default MergeFilesButton;
